import { connect } from 'react-redux'
import WorkshiftRowCompoment from '../../../components/employer/workshifts/workshiftRow.compoment'
import {
  getWorkshiftbyId,
  deleteWorkshift,
  cancelDialog,
  removeWorkshift,
  confirmBillableHour,
  pinWorkshift,
  showWorkshiftFormDialog
} from '../../../actions/employer'

const mapStateToProps = (state) => {
  return {
    state,
    showDeleteDialog: state.workshifts.showDeleteDialog,
    deleteWorkshiftSuccess: state.workshifts.deleteWorkshiftSuccess,
    emailSelectionList: state.workshifts.emailSelectionList
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getWorkshiftbyId: (workshiftId) => dispatch(getWorkshiftbyId(workshiftId)),
    deleteWorkshift: (workshiftid, workshift_itemid) =>
      dispatch(deleteWorkshift(workshiftid, workshift_itemid)),
    cancelDialog: () => dispatch(cancelDialog()),
    removeWorkshift: (workshiftid, workshift_itemid) =>
      dispatch(removeWorkshift(workshiftid, workshift_itemid)),
    confirmBillableHour: (values) => dispatch(confirmBillableHour(values)),
    pinWorkshift: (workshift_itemid) =>
      dispatch(pinWorkshift(workshift_itemid)),
    showWorkshiftFormDialog: () => dispatch(showWorkshiftFormDialog())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const WorkshiftRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorkshiftRowCompoment)

export default WorkshiftRowContainer
